// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"87f2541f","879":"a22f1b9b"}[chunkId] + ".chunk.js";
};